import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { approve_reject_import_member_req } from "../../../data/ApiEndpoints";

const ImportMemberApprovalForm = ({
  userInfoData,
  cardName,
  rowData,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    remarks: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    setIsSubmit(false);
    const { name, value } = e.target;

    setFormValues((prevs) => ({
      ...prevs,
      [name]: value,
    }));
  };

  const onSubmit = () => {
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = approve_reject_import_member_req;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        aprv_rej_description: formValues.remarks || "",
        approval_status: cardName === "reject" ? 2 : 1,
        import_member_ids: [rowData?.uid || ""],
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className={`createNewCTOModalContainer"mod-width-50p"`}>
      <CommonHeadingNBtns
        title={`${cardName} import member Request`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer mb30">
        <div className="formInputsGrid oneGridSystem">
          <div className="formInputBox span4">
            <label htmlFor="remarks" className="formInputLabel">
              remarks{" "}
              <span className="not required">(Optional)</span>
            </label>

            <textarea
              name="remarks"
              className={`formInput ${formErrors.remarks ? "formError" : ""}`}
              placeholder="Enter Remarks"
              value={formValues.remarks}
              onChange={onChangeInput}
            ></textarea>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ImportMemberApprovalForm;
